import trespImg from '../components/img/img3p.png'
import avicolaImg from '../components/img/avicolaImg.png'
import web_tresp from '../components/img/web_3p.PNG'
import tresRayaImg from '../components/img/3_enRaya.PNG'
import vamasImg from '../components/img/vamas.png'

export const Bio = {
    name: "Luis David",
    roles: [
      "Full Stack Developer",      
      "Programador",
    ],
    description:
      "Soy una persona motivada y polivalente, siempre con ganas de afrontar nuevos retos. Con pasión por aprender; me dedico a ofrecer resultados de alta calidad; con una actitud positiva y una mentalidad de crecimiento, estoy listo para hacer una contribución significativa y lograr grandes cosas.",
    github: "https://github.com/luy06D",
    resume:
      "https://drive.google.com/file/d/1yiCURBzF91vNvGyhlYI9wmceasJHs4dB/view?usp=sharing",
    // linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    whasap: "https://wa.me/51934651825?text=Hola",
    insta: "https://www.instagram.com/iam.luisdv/",
    facebook: "https://www.facebook.com/luisdavid.cusigonzales?mibextid=ZbWKwL",    
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },

        {
          name: "HTML5",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        // {
        //   name: "Material UI",
        //   image:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
        // },
        // {
        //   name: "Flutter",
        //   image:
        //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
        // },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "PHP",
          image:
            "https://www.php.net/images/logos/new-php-logo.svg",
        },
        {
          name: "C#",
          image: "https://upload.wikimedia.org/wikipedia/commons/4/4f/Csharp_Logo.png",
        },
        // {
        //   name: "Python",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        // },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        // {
        //   name: "Postgresql",
        //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        // },
        // {
        //   name: "MongoDB",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        // },
        // {
        //   name: "Firebase",
        //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        // },
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "XML",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
        },
        {
          name: "Android Studio",
          image:
            "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
      ],
    },
    {
      title: "Herramientas",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },

        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://cdn.worldvectorlogo.com/logos/postman.svg",
        },

      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: vamasImg,
      role: "Practicante | Programador front-end",
      company: "VAMAS S.A.C",
      date: "Marz 2023 - Jun 2023",
      desc: "Estuve como practicante en la empresa VAMAS trabajando con el equipo de front-end para el diseño de un ERP",
      skills: [
        "Boostrap",
        "React",
        "NodeJS",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      doc: "",
    },
    {
      id: 1,
      img: trespImg,
      role: "Practicante | Programador full stack",
      company: "3P Ingenieria y Tecnologia ",
      date: "Jul 2023 - Present",
      desc: "En mi periodo como practicante en la empresa 3P , participe en la creación de un sistema web para una empresa avicola , que se encuentra entre los valiosos clientes de la empresa, mi rol como practicante me permitió contribuir en el proceso de analisis y desarrollo del sofware.",
      skills: [
        "PHP",
        "Boostrap",
        "AJAX",
        "HTML",
        "CSS",
        "Mysql",
        "JavaScript",
      ],
      doc: "",
    },
    {
      id: 1,
      img: trespImg,
      role: "Practicante | Programador full stack",
      company: "3P Ingenieria y Tecnologia ",
      date: "Oct 2023 - Dic 2023",
      desc: "Estuve realizando un proyecto de innovación en la empresa 3P para culminar mis estudios, en este caso mi proyecto de innovación fue desarrollar un sistema de Gestión de Servicios y venta de equipos",
      skills: [
        "PHP",
        "Boostrap",
        "AJAX",
        "HTML",
        "CSS",
        "Mysql",
        "JavaScript",
        "Librerias",
        
      ],
      doc: "",
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://static.mercadonegro.pe/wp-content/uploads/2017/10/27160609/22815135_916150281870460_820360796721820140_n.jpg",
      school: "Instituto SENATI sede-Chincha",
      date: "Marz 2020 - Oct 2023",
      // grade: "8.71 CGPA",
      desc: "Actualmente soy egresado de la carrera tecnica en Ingenieria de Software del Instituto SENATI. He completado ya 6 semestres de mi carrera en la cual lleve cursos de Desarrollo de APPS moviles II, Cloud Computing, Inteligencia de Negocios y Dataware, y Redes Neuronales.",
      degree: "Profesional Tecnico en Desarrollo de Software con I.A",
    },
    {
      id: 1,
      img: "https://cdn.podimo.com/images/20f436b3-769c-426f-b0bd-08848f505163_400x400.png",
      school: "Universidad Tecnologica del Perú",
      date: "Marz 2024 - Present",
      // grade: "Ciclo I",
      desc: "Actualmente estoy estudiando en la UTP (Universidad Tecnológica del Perú) con el objetivo de complementar mi carrera técnica y convertirme en Ingeniero de Software.",
      degree: "Profesional en Ingeniería de Software",
    },

  ];
  
  export const projects = [
  
    {
      id: 0,
      title: "Sistema de Gestion de Servicios",
      date: "Jul 2023 - Dic 2023",
      description:
        "Actualmente desarrollando un sistema web para la gestion de servicios y ventas de equipos",
      image:
        web_tresp,
      tags: ["JavaScript", "Ajax", "PHP", "Mysql", "Boostrap"],
      category: "web app",
      github: "https://github.com/rishavchanda/Podstream",
      webapp: "https://podstream.netlify.app/",
      // member: [
      //   {
      //     name: "Rishav Chanda",
      //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
      //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
      //     github: "https://github.com/rishavchanda/",
      //   },
      //   {
      //     name: "Upasana Chaudhuri",
      //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
      //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
      //     github: "https://github.com/upasana0710",
      //   },
      // ],
    },
    {
      id: 1,
      title: "Sistema avicola",
      date: "Jul 2023 - Sep 2023",
      description:
        "Diseñe y desarrolle un sistema para venta y almacen de insumos de una avicola",
      image:
        avicolaImg,
      tags: [
        
        "JavaScript",
        "Ajax",
        "PHP",
        "Mysql",
        "Boostrap",
        
      ],
      category: "web app",
      github: "https://github.com/rishavchanda/Project-Management-App",
      webapp: "https://vexa-app.netlify.app/",
    },
    {
      id: 2,
      title: "TRES EN RAYA",
      date: "Ene 22/2024 - Ene 23/2024",
      description:
        "Se recreo un juego clasico llamado tres en raya con React",
      image:
        tresRayaImg,
      tags: [
        
        "JavaScript",
        "React",
        "HTML5",
        "CSS3",
        "GamePlay",
        
      ],
      category: "web game",
      github: "https://github.com/rishavchanda/Project-Management-App",
      webapp: "https://vexa-app.netlify.app/",
    },
    // {
    //   id: 2,
    //   title: "Brain Tumor Detection",
    //   date: "Jan 2023 - Mar 2023",
    //   description:
    //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    //   image:
    //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    //   webapp: "https://brain-tumor.netlify.app/",
    //   member: [
    //     {
    //       name: "Rishav Chanda",
    //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //       github: "https://github.com/rishavchanda/",
    //     },
    //     {
    //       name: "Upasana Chaudhuri",
    //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //       github: "https://github.com/upasana0710",
    //     },
    //   ],
    // },
    // {
    //   id: 3,
    //   title: "Buckoid",
    //   date: "Dec 2021 - Apr 2022",
    //   description:
    //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    //   image:
    //     "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
    //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    // },
    // {
    //   id: 10,
    //   title: "Job Finding App",
    //   date: "Jun 2023 - Jul 2023",
    //   description:
    //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    //   image:
    //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    //   tags: ["React Native", "JavaScript", "Axios"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Job-finder-App",
    //   webapp: "https://github.com/rishavchanda/Job-finder-App",
    // },



    // {
    //   id: 7,
    //   title: "Quiz App",
    //   date: "Dec 2020 - Jan 2021",
    //   description:
    //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    //   image:
    //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Quiz-Earn",
    //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
    // },
    // {
    //   id: 8,
    //   title: "Face Recognition",
    //   date: "Jan 2021",
    //   description:
    //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    //   image:
    //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];